export class AggregatedInvoiceLine {
  code: string;
  labelFR: string;
  labelEN: string;
  labelNL: string;
  totalVATIncluded: number;
}
